module.exports = __webpack_public_path__ + "img/cooperate_35.fc95128c.png";